import { render } from "./menu.vue?vue&type=template&id=6b71904e&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=6b71904e&lang=scss&scoped=true"
import "./menu.vue?vue&type=style&index=1&id=6b71904e&lang=scss"
script.render = render
script.__scopeId = "data-v-6b71904e"

export default script